import {useRef, useState} from "react";
import styles from "@styles/pages/media/detail.module.scss";
import * as React from "react";
import {Autoplay, EffectFade, Navigation, Pagination as SwiperPagination} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";
import {MediaImageSliderData} from "../../config/MediaImageSlider";
import qs from "qs";

// @ts-ignore
import Pagination from 'react-js-pagination';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import Link from "next/link";
// @ts-ignore
import {Document, Page, pdfjs} from 'react-pdf';
import {CantFindWhatYouAreLooking} from "@components/media/cantfindwhatyouarelooking";

// @ts-ignore
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import {useInView} from "framer-motion";
import {Typewriter} from "react-simple-typewriter";
import {strapi} from "@api/Strapi";
import {parseISO, format} from 'date-fns';
import Head from "next/head";
import Script from "next/script";
import {YouMayAlsoLikeHoneyList} from "@components/you-may-also-like-honey-list";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

// @ts-ignore
function Media({mediaDetail, mediaList, pdfDetails, mediaStructuredData, relatedProducts}) {

    /**
     * Media images swiper configuration
     */
    const swiperConfigImages = {
        modules: [Navigation, SwiperPagination, EffectFade, Autoplay],
        spaceBetween: 60.4,
        centeredSlides: true,
        centeredSlidesBounds: true,
        initialSlide: 0,
        loop: true,
        fade: "true",
        speed: 600,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 70,
            },
            481: {
                slidesPerView: 1.5,
                spaceBetween: 40,
            },
            768: {
                slidesPerView: 1.7,
                spaceBetween: 40,
            },
            1025: {
                slidesPerView: 1.629,
                spaceBetween: 60.4,
            },
            1201: {
                slidesPerView: 1.629,
                spaceBetween: 60.4,
            }
        }
    }

    // News swiper instance
    const [swiperNewsRef, setSwiperNewsRef] = useState(null);

    /**
     * News swiper configuration
     */
    const swiperConfigNews = {
        modules: [Navigation, SwiperPagination, EffectFade],
        spaceBetween: 0,
        initialSlide: 1,
        centeredSlides: true,
        centeredSlidesBounds: true,
        fade: "true",
        pagination: {
            el: ".swiper-pagination-news-1",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            481: {
                slidesPerView: 2.15,
                spaceBetween: 0,
                centeredSlides: false,
                centeredSlidesBounds: false,
            },
            768: {
                slidesPerView: 2.15,
                spaceBetween: 0,
                centeredSlides: false,
                centeredSlidesBounds: false,
            },
            1025: {
                slidesPerView: 3.15,
                spaceBetween: 60,
            },
            1201: {
                slidesPerView: 3.922,
                spaceBetween: 60,
            }
        }
    }

    /**
     * To set active page and handle the click action
     */
    const [activePage, setActivePage] = useState(1);
    const handlePageChange = (pageNumber: number) => {
        setActivePage(pageNumber);
        if (swiperNewsRef) {
            // @ts-ignore
            swiperNewsRef.slideTo(pageNumber);
        }
    }

    // these variables are used to animate the left and right image when this view are on screen.
    const ref = useRef(null);
    const isInView = useInView(ref, {once: false});

    /**
     * Video element ref.
     */
    const [activeVideoElement, setActiveVideoElement] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);

    /**
     * The privacy policy page contain about the company privacy policy
     * The text are managed via 3 different styles and one for list.
     */
    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{__html: JSON.stringify(mediaStructuredData)}}
                />
            </Head>
            <section className={styles.banner}>
                <div className={'details_container'}>
                    <div>sidr now</div>
                    <div className={'title_text'}>
                        <Typewriter
                            words={['latest media', 'launches', 'events', 'partnerships']}
                            loop={true}
                            typeSpeed={120}
                            deleteSpeed={90}
                            delaySpeed={1500}
                        />
                    </div>
                </div>
            </section>
            <section className={styles.container}>
                <div className={'content'}>
                    <h1>{mediaDetail.Title}</h1><br/>
                    <div id={'media_detail'} dangerouslySetInnerHTML={{__html: mediaDetail.Detail}}>
                    </div>
                </div>
                <hr/>
                {/*<div className={'about_sidr'}>*/}
                {/*    <h2>about sidr</h2><br/>*/}
                {/*    <p>*/}
                {/*        At SIDR, our primary focus is on the Food and Consumer. Founded in 2021, American-owned*/}
                {/*        investment business with rich heritage and diversified products. We create a healthier world by*/}
                {/*        bringing natural, pure, organic, nutritious and healthy honey products that we believe add value*/}
                {/*        in health and wellness to our customers.*/}
                {/*        <br/><br/>*/}
                {/*        As one of the finest honey brand in the world, SIDR is committed to the sustainable success of*/}
                {/*        all of our businesses. That’s why, when we invest with partners and vendors, we work in close,*/}
                {/*        long-term partnership with our contractors in order to grow the business. We provide global*/}
                {/*        insights and advise on international best practices. We also monitor performance, and*/}
                {/*        continuously examining portfolio contractors for value added exits.*/}
                {/*        <br/><br/>*/}
                {/*        Our products create transformational experiences for people to live happy, healthy, fun lives —*/}
                {/*        over and*/}
                {/*        over again.*/}
                {/*    </p>*/}
                {/*</div>*/}
            </section>
            {/* Other Related Products */}
            <YouMayAlsoLikeHoneyList title={'you may also try'} honeyList={relatedProducts}></YouMayAlsoLikeHoneyList>
            <section className={styles.sidr_news}>
                <Swiper {...swiperConfigNews} onSwiper={(swiper) => {
                    // @ts-ignore
                    setSwiperNewsRef(swiper)
                }} slidesPerView={'auto'}>
                    {
                        mediaList.map((item: any, index: number) => {
                            return (<SwiperSlide key={'image-' + index} onClick={() => {
                                handlePageChange(index)
                            }}>
                                <Link key={'news-' + index} href={item.attributes.Link}
                                      className={`media_item`}>
                                    <p>{item.attributes.Title}</p>
                                    <span
                                        className={'date'}>{format(parseISO(item.attributes.Date), 'LLL d, yyyy')}</span>
                                </Link>
                            </SwiperSlide>)
                        })
                    }
                    <div className={'swiper-pagination-news'}>
                        {
                            Array(~~(5)).fill(0).map((_, index) => {
                                return (
                                    <span key={'dot-news-' + index}
                                          className={`swiper-pagination-bullet ${activePage == index ? 'swiper-pagination-bullet-active' : ''}`}
                                          tabIndex={0}
                                          role="button" onClick={() => {
                                        handlePageChange(index)
                                    }} aria-label={`Go to slide ${index}`}></span>)
                            })
                        }
                    </div>
                </Swiper>
            </section>
            <section className={styles.sidr_in_action} ref={ref}>
                <h3 className={'title_text'}>sidr in action</h3>
                <Swiper {...swiperConfigImages} slidesPerView={'auto'} onSlideChange={(swiper) => {
                    if (activeVideoElement) {
                        setIsPlaying(false)
                        // @ts-ignore
                        activeVideoElement.pause();
                        // @ts-ignore
                        activeVideoElement.removeEventListener('ended', () => {
                        })
                        setActiveVideoElement(null);
                    }
                }}>
                    {
                        MediaImageSliderData.map((item, index) => {
                            return (<SwiperSlide key={'image-' + index}>
                                <div className={`${isPlaying ? 'disable' : ''}`}>
                                    {
                                        item.videoUrl ?
                                            <>
                                                <video poster={item.imageUrl} playsInline={true}>
                                                    <source src={item.videoUrl}
                                                            type={'video/mp4'}/>
                                                    <source src={item.videoUrlWebm}
                                                            type={'video/webm'}/>
                                                </video>
                                                <div className={'play_video'}>
                                                    <div className={'container'}>
                                                        <img onClick={() => {
                                                            const currentDiv = document.getElementsByClassName("swiper-slide-active");
                                                            if (currentDiv[1].children[0].children.length > 1) {
                                                                const videoElement = currentDiv[1].children[0].children[0];
                                                                // @ts-ignore
                                                                setActiveVideoElement(videoElement);
                                                                if (videoElement) {
                                                                    setIsPlaying(true)
                                                                    // @ts-ignore
                                                                    videoElement.play();
                                                                    videoElement.addEventListener('ended', () => {
                                                                        setIsPlaying(false);
                                                                    }, false);
                                                                }
                                                            }
                                                        }}
                                                             src={'/assets/images/decorations/media/sidr_in_action_play_button.webp'}
                                                             alt={'play'}/>
                                                        <span>
                                                        Press Video <br/>{item.hoverTitle}
                                                    </span>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <img loading={"lazy"}
                                                 src={item.imageUrl} alt={item.imageAltText}/>
                                    }
                                </div>
                            </SwiperSlide>)
                        })
                    }
                    <div className={`over_image_container ${isInView ? 'image_animation' : ''}`}>
                        <img src={'/assets/images/decorations/media/media_sidr_in_action.webp'} alt={'sidr media'}/>
                    </div>
                    <div className={'swiper-pagination'}>
                        {
                            MediaImageSliderData.map((_, index) => {
                                return (
                                    <span key={'dot-honey-' + index} className="swiper-pagination-bullet" tabIndex={0}
                                          role="button"
                                          aria-label={`Go to slide ${index}`}></span>)
                            })
                        }
                    </div>
                </Swiper>

            </section>
            {
                pdfDetails &&
                <section className={styles.sidr_media_kit}>
                    <div className={'title_text'}>media kit</div>
                    <div className={'container'}>
                        <div className={'item'}>
                            <Document file={pdfDetails.Products_Catalog.data.attributes.url}
                                      options={{workerSrc: "/pdf.worker.js"}}>
                                <Page pageNumber={1}/>
                            </Document>
                            <span>{pdfDetails.Products_Catalog.data.attributes.caption ? pdfDetails.Products_Catalog.data.attributes.caption : pdfDetails.Products_Catalog.data.attributes.alternativeText}</span>
                            <Link href={pdfDetails.Products_Catalog.data.attributes.url} className={'download_catalog'}
                                  target={"_blank"}
                                  download={pdfDetails.Products_Catalog.data.attributes.caption ? pdfDetails.Products_Catalog.data.attributes.caption : pdfDetails.Products_Catalog.data.attributes.alternativeText}>
                                Download
                            </Link>
                        </div>

                        <div className={'item'}>
                            <Document file={pdfDetails.Wordmark.data.attributes.url}
                                      options={{workerSrc: "/pdf.worker.js"}}>
                                <Page pageNumber={1}/>
                            </Document>
                            <span>{pdfDetails.Wordmark.data.attributes.caption ? pdfDetails.Wordmark.data.attributes.caption : pdfDetails.Wordmark.data.attributes.alternativeText}</span>
                            <Link href={pdfDetails.Wordmark.data.attributes.url} className={'download_catalog'}
                                  target={"_blank"}
                                  download={pdfDetails.Wordmark.data.attributes.caption ? pdfDetails.Wordmark.data.attributes.caption : pdfDetails.Wordmark.data.attributes.alternativeText}>
                                Download
                            </Link>
                        </div>

                        <div className={'item'}>
                            <Document file={pdfDetails.Brand_Architecture.data.attributes.url}
                                      options={{workerSrc: "/pdf.worker.js"}}>
                                <Page pageNumber={1}/>
                            </Document>
                            <span>{pdfDetails.Brand_Architecture.data.attributes.caption ? pdfDetails.Brand_Architecture.data.attributes.caption : pdfDetails.Brand_Architecture.data.attributes.alternativeText}</span>
                            <Link href={pdfDetails.Brand_Architecture.data.attributes.url}
                                  className={'download_catalog'}
                                  target={"_blank"}
                                  download={pdfDetails.Brand_Architecture.data.attributes.caption ? pdfDetails.Brand_Architecture.data.attributes.caption : pdfDetails.Brand_Architecture.data.attributes.alternativeText}>
                                Download
                            </Link>
                        </div>
                    </div>
                </section>
            }
            <CantFindWhatYouAreLooking></CantFindWhatYouAreLooking>
        </>
    )
}

export async function getServerSideProps(context: { params: { detail: any; }; resolvedUrl: string; }) {

    const key = context.params.detail;
    let mediaDetail = null

    let mediaId: any = null;
    const response = await strapi.getMedia(key);
    if (response.status == 200 && response.data && response.data.data) {
        if (response.data.data.length > 0) {
            mediaId = response.data.data[0].id;
            mediaDetail = response.data.data[0].attributes;
        }
    }

    let mediaList: any = []
    const pagination = `pagination[page]=${1}&pagination[pageSize]=${5}`;
    const responseList = await strapi.getMediaList(pagination);
    if (responseList.status == 200 && responseList.data && responseList.data.data) {

        mediaList = responseList.data.data;
    }


    let pdfDetails = null;
    const responsePdf = await strapi.getPDF();
    if (responsePdf.status == 200 && responsePdf.data && responsePdf.data.data) {
        pdfDetails = responsePdf.data.data.attributes;
    }

    if (!mediaDetail) {
        return {
            notFound: true,
        }
    }

    // Related Products
    let relatedProducts = []
    let queryObjectRelatedProducts: any = {
        pagination: {
            page: 1,
            pageSize: 4
        },
        filters: {
            Collection: {
                Link: {$eq: 'honey'}
            }
        },
        sort: ['Views:desc'],
    }
    let queryRelatedProducts = qs.stringify(queryObjectRelatedProducts, {encodeValuesOnly: true,});
    try {
        const responseRelatedProducts = await strapi.getProductsList(queryRelatedProducts);
        if (responseRelatedProducts.status == 200 && responseRelatedProducts.data && responseRelatedProducts.data.data) {
            relatedProducts = responseRelatedProducts.data.data;
        }
    } catch (e) {

    }
    // Update View Count
    try {
        let totalViews = mediaDetail.Views == null ? 0 : parseInt(mediaDetail.Views)
        await strapi.updateMediaView(mediaId, {data: {Views: totalViews + 1}})
    } catch (e) {
    }

    let seoDetails: any = {
        title: `${mediaDetail.SEO_Title ? mediaDetail.SEO_Title : mediaDetail.Title} | SIDR®`,
        url: context.resolvedUrl,
        description: mediaDetail.SEO_Description,
        keyword: mediaDetail.SEO_Keyword,
    }
    if (mediaDetail.SEO_Image.data) {
        seoDetails['image'] = mediaDetail.SEO_Image.data.attributes.url;
        seoDetails['imageAlt'] = mediaDetail.SEO_Image.data.attributes.alternativeText;
    }

    let mediaStructuredData = {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        "headline": (mediaDetail.SEO_Title ? mediaDetail.SEO_Title : mediaDetail.Title.replace(/(<([^>]+)>)/g, "")),
        "articleBody": mediaDetail.Detail,
        "datePublished": mediaDetail.publishedAt,
        "dateModified": mediaDetail.updatedAt,
    }
    return {props: {mediaDetail, mediaList, pdfDetails, seoDetails, mediaStructuredData, relatedProducts}}
}

export default Media;
